import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CustomerModel} from '../../models/customer.model';
import {DocumentModel} from '../../models/document.model';
import {ModalController} from '@ionic/angular';
import {LokijsService} from '../../services/database/lokijs.service';
import {CustomerResourceService} from '../../services/database/resource/customer-resource.service';
import {SearchcustomerPage} from '../../modals/searchcustomer/searchcustomer.page';
import {OrdersForCustomerPage} from '../../modals/orders-for-customer/orders-for-customer.page';
import {MobileConfigurationModel} from '../../models/mobile-configuration.model';
import {ConfigurationService} from '../../services/configuration.service';

@Component({
    selector: 'customer-return',
    templateUrl: './customer-return.component.html',
    styleUrls: ['./customer-return.component.scss'],
})
export class CustomerReturnComponent implements OnInit {
    @Input() document: DocumentModel;
    @Output() customerChange: EventEmitter<CustomerModel> = new EventEmitter<CustomerModel>();
    @Output() documentChange: EventEmitter<DocumentModel> = new EventEmitter<DocumentModel>();
    customerList: any;
    mobileConfiguration: MobileConfigurationModel;

    constructor(private modalController: ModalController,
                private lokiJs: LokijsService,
                private customerRes: CustomerResourceService,
                private configService: ConfigurationService) {
    }

    async ngOnInit() {
        this.mobileConfiguration = await this.configService.getMobileConfiguration();
        this.customerList = this.lokiJs.getCollection('customer').chain().simplesort('name').data();
        // if (!this.document.customer.name) {
        //     this.openModal(1);
        // }
    }

    async openModal(ind) {
        // The 'ind' parameter is used to open a certain modal.
        let page = null;
        if (ind === 1) {
            page = SearchcustomerPage;
        } else if (ind === 2) {
            page = OrdersForCustomerPage;
        }
        const modal = await this.modalController.create({
            component: page,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'customerList': this.customerList,
                'document': this.document,
                'type': 'contract',
                'customer': this.document.customer.id
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                if (ind === 1) {
                    this.customerChange.emit(dataReturned.data);
                    console.log(dataReturned.data);
                } else if (ind === 2) {
                    this.documentChange.emit(dataReturned.data);
                    console.log(dataReturned.data);
                }
            } else {
                if (!this.document.customer.name) {
                    this.modalController.dismiss();
                }
            }
        });

        return await modal.present();
    }

}
